module.exports = function getRequestType(type) {
    switch(type) {
        case 'packageLicencePlate':
            return 'Timpex.Traffic.Trace.ByConsignment.TraceByPackageLicencePlateRequest';
        case 'waybill':
            return 'Timpex.Traffic.Trace.ByConsignment.TraceByWayBillNoRequest';
        case 'sendersReference':
            return 'Timpex.Traffic.Trace.ByConsignment.TraceBySendersReferenceRequest';
        default:
            throw new Error(`Unknown search type: ${type}`);
    }
};
